import { z } from 'zod';

/**
 * Media type of the asset resource. Includes images, attachments, presentations, spreadsheets, pdfdocuments, archives, and videos.
 * @typedef ContentType
 */

export const ContentTypeSchema = z.enum([
  'image/gif',
  'image/jpeg',
  'image/png',
  'application/json',
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.oasis.opendocument.presentation',
  'application/vnd.oasis.opendocument.spreadsheet',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/gzip',
  'application/x-tar',
  'application/x-7z-compressed',
  'application/zip',
  'video/mp4',
  'video/mpeg'
]);

export type ContentType = z.infer<typeof ContentTypeSchema>;
